const extend = require('extend');
const Q = require('q');
const _ = require('underscore');
const moment = require('moment');
const URI = require(`urijs`);
const OssClient = require(`nllib/src/system-docking/aliyun/oss/frontend/client`);
const get_uuid = require('nllib/src/common/get_uuid');
const web_common_oss_sts = require(`../../../../../../data-service/default/web_common_oss_sts`);

const get_environment = function () {
    const appConfig = global.appConfig;
    if (!appConfig) {
        const msg = 'get_environment parameter error, code=001';
        console.error(msg);
        console.trace();
        return ``;
    }
    const environment = appConfig.environment;
    if (!environment) {
        const msg = 'get_environment parameter error, code=002';
        console.error(msg);
        console.trace();
        return ``;
    }
    return environment;
};

const get_bucket = function (pParameter) {
    if (!pParameter) pParameter = {};
    const environment = pParameter.environment;

    let r;
    if (environment === `release`) {
        r = `yinzhilv-file-bucket-release`;
    } else {
        r = `yinzhilv-file-bucket-alpha`;
    }
    return r;
};

module.exports = function (pInitParameter) {
    const __this = this;

    const defaultInitParameter = {};

    const initParameter = extend(true, {}, defaultInitParameter, pInitParameter);

    let environment;
    let bucket;
    const region = `oss-cn-shenzhen`;

    let __client;

    const init = function () {
        environment = get_environment();
        if (!environment) {
            const msg = 'init parameter error, code=001';
            console.error(msg);
            console.trace();
            return Q.reject({msg: msg});
        }

        bucket = get_bucket({
            environment,
        });

        __client = new OssClient({
            initType: '100',
            initTypeParameter: {
                '100': {
                    region: region,
                    bucket: bucket,
                    getAuthInfo: function () {
                        return Q.when()
                            .then(function () {
                                return web_common_oss_sts();
                            })
                            .then(function (data) {
                                const __data = {};
                                if (!data) {
                                    return Q.resolve(__data);
                                }
                                const credentials = data.credentials;
                                if (!credentials) {
                                    return Q.resolve(__data);
                                }

                                __data.accessKeyId = credentials.accessKeyId;
                                __data.accessKeySecret = credentials.accessKeySecret;
                                __data.stsToken = credentials.securityToken;

                                return Q.resolve(__data);
                            })
                            ;
                    }
                }
            }
        });
    };
    init();

    const multipartUpload = function (pParameter) {
        if (!pParameter) pParameter = {};
        const file = pParameter.file;
        const progress = pParameter.progress;

        if (!file) {
            const msg = 'multipartUpload parameter error, code=001';
            console.error(msg);
            console.trace();
            return Q.reject({msg: msg});
        }
        const file_name_001 = file.name;
        if (!file_name_001) {
            const msg = 'multipartUpload parameter error, code=002';
            console.error(msg);
            console.trace();
            return Q.reject({msg: msg});
        }
        const file_name_002 = file_name_001
            .replace(/%/gi, ``)
        ;

        const uuid = get_uuid();
        const now = moment();
        const name = `${environment}/${now.format(`YYYY`)}/${now.format(`MM`)}/${now.format(`DD`)}/${now.format(`HH`)}/${uuid}/${file_name_002}`;

        return Q.when()
            .then(function () {
                return __client.multipartUpload(name, file, {
                    progress: progress,
                });
            })
            .then(function (data) {
                if (!data) {
                    const msg = `multipartUpload parameter error, code=001`;
                    console.error(msg);
                    console.trace();
                    return Q.reject({msg: msg});
                }

                const url = data.url;
                if (!url) {
                    const msg = `multipartUpload parameter error, code=002`;
                    console.error(msg);
                    console.trace();
                    return Q.reject({msg: msg});
                }

                data.url = url;

                return Q.resolve(data);
            })
            .catch(function (ex) {
                console.error(ex);
                if (ex.stack) {
                    console.error(ex.stack);
                }
                return Q.reject(ex);
            })
            ;
    };
    __this.multipartUpload = multipartUpload;
};
